import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CaretExpanderComponent } from '../caret-expander/caret-expander.component';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { TreeviewService } from './treeview.service';
import { NkTreeviewNode } from './treeview.utils';

@Component({
  selector: 'nk-treeview-node',
  imports: [FormsModule, CaretExpanderComponent, CheckboxComponent],
  templateUrl: './treeview-node.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class TreeviewNodeComponent<T> {
  public nodes = input<NkTreeviewNode<T>[]>([]);
  public andClass = input<string>('');
  private _treeviewService = inject<TreeviewService<T>>(TreeviewService);

  public toggleExpand(node: NkTreeviewNode<T>, isExpanded: boolean): void {
    this._treeviewService.toggleExpand(node.id, isExpanded);
  }

  public updateChecked(node: NkTreeviewNode<T>, isChecked: boolean): void {
    this._treeviewService.toggleChecked(node.id, isChecked);
  }
}
